import { createApi } from '@reduxjs/toolkit/query/react';
import type { AxiosRequestConfig } from 'axios';

import { requestService } from 'shared/utils/services/requestService';

// Create our own base query function using request service
// Ref: https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
const requestServiceBaseQuery = async (options: AxiosRequestConfig) => {
  try {
    const result = await requestService(options);
    return { data: result };
  } catch (error) {
    return {
      error: {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      },
    };
  }
};

// Ref: https://redux.js.org/tutorials/essentials/part-7-rtk-query-basics#defining-an-api-slice
export const apiSlice = createApi({
  baseQuery: requestServiceBaseQuery,
  /**
   * Endpoints are left blank here since they are injected later in the codebase
   */
  endpoints: () => ({}),
});
